export const getExternalSettings = async () => {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL}/appSettings.json`);

    return await res.json();
  } catch (e) {
    return await Promise.reject(e);
  }
};
